import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e8ab70d")

_pushScopeId("data-v-3e8ab70d")
const _hoisted_1 = { class: "flex flex-col gap-y-4 p-4 bg-gray-lp-1000 h-screen" }
const _hoisted_2 = { class: "input-scan w-full" }
const _hoisted_3 = { class: "flex flex-row justify-between items-baseline w-full gap-10" }
const _hoisted_4 = { class: "flex flex-col gap-2 w-1/2" }
const _hoisted_5 = { class: "flex items-center gap-x-4 py-2 justify-between" }
const _hoisted_6 = {
  for: "notes",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_7 = { class: "w-1/2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SummaryCollapsible = _resolveComponent("SummaryCollapsible")!
  const _component_CardDeposit = _resolveComponent("CardDeposit")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Notes = _resolveComponent("Notes")!
  const _component_SectionUploadPhotoCodReconcile = _resolveComponent("SectionUploadPhotoCodReconcile")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ImagePreviewReconcile = _resolveComponent("ImagePreviewReconcile")!
  const _component_SttDetailModal = _resolveComponent("SttDetailModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Card, {
        class: "p-4 flex-grow flex flex-col min-h-0 gap-y-4",
        rounded: "2xl"
      }, {
        default: _withId(() => [
          _createVNode(_component_SummaryCollapsible, {
            displayType: "package",
            title: _ctx.$t('codReconcile.detail.totalSttToDeposit'),
            totalString: `${_ctx.courierSummaryCount.totalStt} STT`,
            subtotalString: `(${_ctx.courierSummaryCount.totalSttPieces} ${_ctx.$t('codReconcile.dailyDeposit.koli')})`,
            data: _ctx.listCourierSummary
          }, null, 8, ["title", "totalString", "subtotalString", "data"]),
          _createVNode(_component_CardDeposit, {
            deposits: _ctx.taskSettlementCourier,
            type: "paket"
          }, null, 8, ["deposits"]),
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_LpInput, {
              id: "cod-reconcile-scan",
              ref: "inputStt",
              modelValue: _ctx.sttNumber,
              sizeInput: "24px",
              labelStacked: _ctx.$t('codReconcile.dailyDeposit.exampleStt'),
              placeholder: _ctx.$t('codReconcile.dailyDeposit.placeholderStt'),
              onEnter: _ctx.onScanSttNumber,
              onEvent: _ctx.onFocusStt
            }, null, 8, ["modelValue", "labelStacked", "placeholder", "onEnter", "onEvent"])
          ]),
          _createVNode("div", {
            class: ["overflow-auto", {
          'border border-b-0 border-gray-lp-400 rounded-xl':
            _ctx.detailCourier.length
        }]
          }, [
            _createVNode(_component_TableV2, {
              ref: "detailCourierTable",
              columns: _ctx.columns,
              data: _ctx.isEmptyList ? [] : _ctx.detailCourier,
              isEmpty: _ctx.isEmptyList,
              onRequest: _ctx.getListSttTable,
              "onUpdate:checkedData": _ctx.onSelectData,
              hidePagination: "",
              iconEmpty: _ctx.emptyIcon,
              emptyHeaderMessage: _ctx.emptyTitle,
              emptyMessage: _ctx.emptyMessage,
              bgHeader: "bg-white border-b border-gray-lp-400",
              roundedHeaderLeft: "rounded-tl-lg",
              roundedHeaderRight: "rounded-tr-lg",
              isCheckBox: "",
              marginTopCheckbox: false,
              isSpaceTop: false,
              borderTop: false,
              borderBottom: false,
              iconColor: "green-lp-100",
              isNoPaddingBottom: "",
              isDownloadCheckBox: false
            }, null, 8, ["columns", "data", "isEmpty", "onRequest", "onUpdate:checkedData", "iconEmpty", "emptyHeaderMessage", "emptyMessage"])
          ], 2),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_Notes, {
                notes: _ctx.courierNotes,
                "onUpdate:notes": _cache[2] || (_cache[2] = ($event: any) => (_ctx.courierNotes = $event)),
                loading: _ctx.courierNotesLoading
              }, {
                title: _withId(() => [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.catatan")), 1),
                    _createVNode("button", {
                      class: `text-sm ${_ctx.courierNotes ? 'text-red-lp-100' : 'text-gray-lp-600'} font-semibold`,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmitCourierNotes && _ctx.onSubmitCourierNotes(...args))),
                      disabled: !_ctx.courierNotes
                    }, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.simpan")), 11, ["disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["notes", "loading"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_SectionUploadPhotoCodReconcile, {
                key: JSON.stringify(_ctx.courierNotePhotosUrl),
                modelValue: _ctx.courierNotePhotosUrl,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.courierNotePhotosUrl = $event)),
                iconTitle: false,
                "reconcile-for": "PACKAGE",
                onOnSuccessUploadImage: _ctx.onSubmitCourierNotesPhoto,
                onOnSuccessDeleteImage: _ctx.onSubmitCourierNotesPhoto,
                onPreview: _cache[4] || (_cache[4] = 
              (index) => {
                _ctx.previewCourierNotesPhoto = true;
                _ctx.previewCourierNotesPhotoIndex = index;
              }
            )
              }, null, 8, ["modelValue", "onOnSuccessUploadImage", "onOnSuccessDeleteImage"])
            ])
          ]),
          _createVNode(_component_LpButton, {
            title: `${_ctx.$t('codReconcile.dailyDeposit.setor')} (${_ctx.dataSelected.length} STT)`,
            textColor: "white",
            class: "mt-4",
            disabled: _ctx.isDisabled,
            onClick: _ctx.postCourierDailyDeposit
          }, null, 8, ["title", "disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    (_ctx.previewCourierNotesPhoto)
      ? (_openBlock(), _createBlock(_component_ImagePreviewReconcile, {
          key: 0,
          onClose: _cache[5] || (_cache[5] = () => (_ctx.previewCourierNotesPhoto = false)),
          data: _ctx.courierNotePhotosUrl.filter((url) => url),
          initialIndex: _ctx.previewCourierNotesPhotoIndex
        }, null, 8, ["data", "initialIndex"]))
      : _createCommentVNode("", true),
    (_ctx.isShowModalPreviewImage)
      ? (_openBlock(), _createBlock(_component_ImagePreviewReconcile, {
          key: 1,
          onClose: _cache[6] || (_cache[6] = () => (_ctx.isShowModalPreviewImage = false)),
          data: _ctx.previewImageDetalStt.filter((url) => url),
          initialIndex: 0
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    _createVNode(_component_SttDetailModal, {
      modelValue: _ctx.showModalDetailStt,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModalDetailStt = $event)),
      sttList: _ctx.sttList,
      onClose: _ctx.closeDetailStt
    }, null, 8, ["modelValue", "sttList", "onClose"])
  ], 64))
})